// API配置
export const API_CONFIG = {
  // BASE_URL: "http://192.168.110.21:8080", // 改为相对路径，将通过代理访问
  BASE_URL: "https://aidy.rongyuejiaoyu.com", // 改为相对路径，将通过代理访问
  CHAT_ENDPOINT: "/v1/documents",
  TIMEOUT: 30000,
  ERROR_MESSAGES: {
    NETWORK_ERROR: "网络连接失败，请检查网络设置",
    TIMEOUT_ERROR: "请求超时，请稍后重试",
    SERVER_ERROR: "服务器错误，请稍后重试",
    DEFAULT_ERROR: "请求失败，请稍后重试",
  },
};

export const API_CONFIG_BE = {
  // BASE_URL: "http://192.168.110.21、:8080", // 改为相对路径，将通过代理访问
  BASE_URL: "https://aidy.rongyuejiaoyu.com", // 改为相对路径，将通过代理访问
  CHAT_ENDPOINT: "/v1/be",
  TIMEOUT: 30000,
  TYPING_SPEED: 30, // 打字效果的速度（毫秒）
  THINKING_PAUSE: 300, // 思考到回答的过渡时间（毫秒）
  ERROR_MESSAGES: {
    NETWORK_ERROR: "网络连接失败，请检查网络设置",
    TIMEOUT_ERROR: "请求超时，请稍后重试",
    SERVER_ERROR: "服务器错误，请稍后重试",
    DEFAULT_ERROR: "请求失败，请稍后重试",
  },
};
